import { getSortedQuoteItemIds } from 'modules/quotes/quoteItems/data/selectors';

import { BAQ_PAGE_INIT_REQUEST } from 'store/quotes/types';

import { types } from './actions';

const initialState = {
  isDeepCopyingQuoteItem: false,
  isExpanded: true,
  lastSelectedQuoteItemId: null,
  isFiltered: false,
  filteredQuoteItemIds: [],
  selectedQuoteItemIds: {},
  isDeletingQuoteItems: false,
};

const reducer = (state = initialState, action) => {
  const { payload, type } = action;
  switch (type) {
    case BAQ_PAGE_INIT_REQUEST:
      return {
        ...initialState,
      };
    case types.QUOTE_ITEM_FILTER_SEARCH:
      return {
        ...state,
        isFiltered: payload.value.trim() !== '',
      };
    case types.QUOTE_ITEM_FILTER_CLEAR:
      return {
        ...state,
        isFiltered: false,
        filteredQuoteItemIds: [],
      };
    case types.QUOTE_ITEM_FILTER_SET_FILTERED_IDS: {
      const newSelectedQuoteItemIds = {};
      for (const [quoteItemId, isSelected] of Object.entries(
        state.selectedQuoteItemIds,
      )) {
        if (payload.quoteItemIds.includes(quoteItemId)) {
          newSelectedQuoteItemIds[quoteItemId] = isSelected;
        }
      }
      return {
        ...state,
        filteredQuoteItemIds: payload.quoteItemIds,
        selectedQuoteItemIds: newSelectedQuoteItemIds,
        lastSelectedQuoteItemId:
          newSelectedQuoteItemIds[state.lastSelectedQuoteItemId] == null
            ? null
            : state.lastSelectedQuoteItemId,
      };
    }
    case types.SIDE_NAV_TOGGLE_IS_EXPANDED:
      return {
        ...state,
        isExpanded: !state.isExpanded,
      };
    case types.COPY_QUOTE_ITEMS_IN_QUOTE_SUCCESS:
    case types.MAKE_QUOTE_ITEMS_ASSEMBLIES_SUCCESS:
    case types.BULK_UPDATE_COMPONENTS_SUCCESS:
    case types.QUOTE_ITEM_SELECT_DESELECT_ALL:
      return {
        ...state,
        selectedQuoteItemIds: {},
        lastSelectedQuoteItemId: null,
      };
    case types.QUOTE_ITEM_SELECT_TOGGLE:
      return {
        ...state,
        selectedQuoteItemIds: {
          ...state.selectedQuoteItemIds,
          [payload.quoteItemId]:
            !state.selectedQuoteItemIds[payload.quoteItemId],
        },
        lastSelectedQuoteItemId: payload.quoteItemId,
      };
    case types.QUOTE_ITEM_SELECT_MERGE_SELECTION: {
      const toMerge = {};
      for (const id of payload.quoteItemIds) {
        toMerge[id] = true;
      }
      return {
        ...state,
        selectedQuoteItemIds: {
          ...state.selectedQuoteItemIds,
          ...toMerge,
        },
        lastSelectedQuoteItemId: payload.lastSelection,
      };
    }
    case types.QUOTE_ITEM_SELECT_DESELECT_BULK: {
      const toMerge = {};
      for (const id of payload.quoteItemIds) {
        toMerge[id] = false;
      }
      return {
        ...state,
        selectedQuoteItemIds: {
          ...state.selectedQuoteItemIds,
          ...toMerge,
        },
        lastSelectedQuoteItemId: payload.lastSelection,
      };
    }
    case types.DEEP_COPY_QUOTE_ITEM_REQUEST:
      return {
        ...state,
        isDeepCopyingQuoteItem: true,
      };
    case types.DEEP_COPY_QUOTE_ITEM_ERROR:
    case types.DEEP_COPY_QUOTE_ITEM_SUCCESS:
      return {
        ...state,
        isDeepCopyingQuoteItem: false,
      };
    case types.DELETE_QUOTE_ITEMS_REQUEST:
      return { ...state, isDeletingQuoteItems: true };
    case types.DELETE_QUOTE_ITEMS_ERROR:
      return { ...state, isDeletingQuoteItems: false };
    case types.DELETE_QUOTE_ITEMS_SUCCESS:
      return {
        ...state,
        isDeletingQuoteItems: false,
        selectedQuoteItemIds: {},
        lastSelectedQuoteItemId: null,
      };
    default:
      return state;
  }
};

const getScope = (state) => state.modules.quotes.quoteItemNav.nav;

export const getSelectedQuoteItemIds = (state) =>
  getScope(state).selectedQuoteItemIds;

export const getSelectedQuoteItemIdsArray = (state) => {
  const quoteItemIds = [];
  const selectedQuoteItemIdsObject = getSelectedQuoteItemIds(state);
  for (const [id, value] of Object.entries(selectedQuoteItemIdsObject)) {
    if (value) {
      quoteItemIds.push(parseInt(id));
    }
  }
  return quoteItemIds;
};

export const getSelectedQuoteItemsCount = (state) =>
  getSelectedQuoteItemIdsArray(state).length;

export const getAreBulkActionsInUse = (state) =>
  getSelectedQuoteItemsCount(state) >= 1;

export const isExpanded = (state) => getScope(state).isExpanded;

export const isQuoteItemSelected = (state, quoteItemId) =>
  !!getSelectedQuoteItemIds(state)[quoteItemId];

export const getLastSelectedQuoteItemId = (state) =>
  getScope(state).lastSelectedQuoteItemId;

export const getIsDeepCopyingQuoteItem = (state) =>
  getScope(state).isDeepCopyingQuoteItem;

export const getIsDeletingQuoteItems = (state) =>
  getScope(state).isDeletingQuoteItems;

export const getIsFiltered = (state) => getScope(state).isFiltered;

export const getFilteredQuoteItemIds = (state) => {
  const quoteItemIds = getSortedQuoteItemIds(state);
  const isFiltered = getIsFiltered(state);
  const filteredIds = getScope(state).filteredQuoteItemIds;

  if (!isFiltered) {
    return quoteItemIds;
  }

  if (filteredIds.length === 0) {
    return [];
  }

  return quoteItemIds.filter((id) => filteredIds.includes(id));
};

export default reducer;
